import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

const keepaliveFetch: typeof fetch = (input, init) => {
  const nextInit: RequestInit = init ? { ...init, keepalive: true } : { keepalive: true }
  return fetch(input, nextInit)
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: { fetch: keepaliveFetch },
})

export type AdminRole = 'admin' | 'super_admin' | 'moderator'

const ADMIN_ROLES: ReadonlySet<string> = new Set(['admin', 'super_admin', 'moderator'])

export async function isAdmin(userId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('admin_profiles')
    .select('role')
    .eq('id', userId)
    .maybeSingle()
  if (error || !data) return false
  return ADMIN_ROLES.has((data as { role: string }).role)
}

export async function getAdminRole(userId: string): Promise<AdminRole | null> {
  const { data, error } = await supabase
    .from('admin_profiles')
    .select('role')
    .eq('id', userId)
    .maybeSingle()
  if (error || !data) return null
  const role = (data as { role: string }).role
  return ADMIN_ROLES.has(role) ? (role as AdminRole) : null
}
